<template>
	<!-- 客户发票管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">


					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">时间：</label>
						<div class="el-select public_optionSty">

							<!-- <el-select class="public_optionSty dropDown_Define" v-model="cusQueryTime" placeholder="请选择">
								<el-option v-for="item in orOptions" :key="item.value" :label="item.label"
										   :value="item.value">
								</el-option>
							</el-select> -->

							<el-date-picker v-model="cusQueryTime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>


					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户名称：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="7" type="text" placeholder="请输入客户名称" v-model="cusQueryName"
									clearable></el-input>
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="11" type="text" placeholder="请输入手机号" v-model="cusQueryiphone"
									clearable></el-input>
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户等级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khdj" placeholder="请选择" clearable>
							<el-option v-for="item in khdjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<!-- <div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户星级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khxj" placeholder="请选择">
							<el-option v-for="item in khxjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div> -->
				</div>
				<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList()">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>

					<!-- <el-button class="public_saleWater_quanping" type="primary" :disabled="quanpDisabled" @click="fullScreen">
						<i class="iconfont icon-tuichuquanping1"></i>全屏
					</el-button> -->
				</div>
			</div>

			<div class="statistic">
				<div class="statistic-item">
					<i class="el-icon-search" style="color: #EEB68B;"></i>
					<span style="margin-right: 10px; color: #EBAA7A;">总可开</span>
					<span style="color: #EBAA7A;">{{ zed }}(万元)</span>
				</div>
				<div class="statistic-item">
					<i class="el-icon-tickets" style="color: #86D185"></i>
					<span style="margin-right: 10px; color: #67C668;">总已开</span>
					<span style="color: #67C668;">{{ zyk }}(万元)</span>
				</div>
			</div>

			<div class="billOperationRecord-table pulbic_table_container">
				<el-table tooltip-effect="dark" :data="tableData" @sort-change="onSortChange" style="width: 100%;"
					:default-sort="{ prop: 'waterNum', order: 'descending' }" class="public_tableColumn"
					:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
					<el-table-column prop="ORMTB410CA00" label="客户名称" fixed="left" width="110">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA00 }}</span>
							</p>
							<p style="color: #999;">
								<span>{{ scope.row.ORMTB410CA02 }}</span>
							</p>

						</template>
					</el-table-column>

					<el-table-column prop="kkpmf" sortable label="免费可开"></el-table-column>
					<el-table-column prop="kkpn" sortable label="8.5可开"></el-table-column>
					<el-table-column prop="kkpw" sortable label="8.8可开"></el-table-column>
					<el-table-column prop="kkp91" sortable label="9.1可开"></el-table-column>
					<el-table-column prop="wl" sortable label="物料销售额"></el-table-column>
					<el-table-column prop="yf" sortable label="运费金额"></el-table-column>
					<el-table-column prop="ykpmf" sortable label="免费已开"></el-table-column>
					<el-table-column prop="ykpn" sortable label="8.5已开"></el-table-column>
					<el-table-column prop="ykpw" sortable label="8.8已开"></el-table-column>
					<el-table-column prop="ykp91" sortable label="9.1已开"></el-table-column>
					<el-table-column prop="zxf" sortable label="总额度"></el-table-column>


					<el-table-column prop="ORMTB410CA06" fixed="right" width="150" sortable label="客户等级">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.khdj }}</span>
							</p>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="withdraw" sortable label="累计提现" width="110"></el-table-column> -->
					<!-- <el-table-column prop="score" sortable label="积分"></el-table-column> -->
					<el-table-column label="操作" fixed="right" width="150">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">

								<el-dropdown>
									<span class="el-dropdown-link public_icon_qiyong">
										发票<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiangqing public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="kpjlialClick(scope.row)">开票记录
											</el-button>
										</el-dropdown-item>
										<!-- <el-dropdown-item>
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="fpshjlialClick(scope.row)">发票审核
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_dayin public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="upuserClick(scope.row)">新增开票信息
											</el-button>
										</el-dropdown-item> -->
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_hongchongred public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="cdjlialClick(scope.row)">冲抵记录
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="cduserClick(scope.row)">新增冲抵信息
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiangqing public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="xquserClick(scope.row)">详情
											</el-button>
										</el-dropdown-item>
										<!-- <el-dropdown-item>
											<el-button type="primary" class="public_icon_xiugai public_icon_width" v-shiroHiden="solelist"
												id="修改" size="small" @click="fpshjjjlialClick(scope.row)">
												审核拒绝记录
											</el-button>
										</el-dropdown-item> -->
									</el-dropdown-menu>
								</el-dropdown>

							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>

			<div class="public-dialog">
				<el-dialog title="新增开票信息" :visible.sync="cusUpdateShow" width="30%" @close="kpmsgClose"
					:closeOnClickModal='false'>
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusUpdateObj.ORMTB410CA00" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusUpdateObj.ORMTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">可开票额度:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusUpdateObj.zkk" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">开票额度类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<template>
									<el-select v-model="kpedlxValue" placeholder="请选择">
										<el-option v-for="item in kpedlx" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</template>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="">
							<el-upload :class="{ disabled: uploadDisabled }" ref="upload" :auto-upload="false" action=""
								:on-success="handleUploadSuccess" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :on-change="handleChange" :on-exceed="handleExceed"
								:file-list="fileList" :accept="acceptFormat" :limit="limitNum" :multiple="false" drag>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
								<div class="el-upload__tip" slot="tip" style="font-size:20px; color: red;">
									只能上传{{ acceptFormat }}格式的文件，每次上传的文件数量不能超过{{ limitNum }}个</div>
							</el-upload>

						</div>

						<div class="customerManagementPC-add-customer" style="padding-top: 40px;"
							v-if="fpdialogImageUrl">
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">名称:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.xftt" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">税号:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.xfsh" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">账号:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="cusUpdateObj.SETTB410CA05" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">开票金额:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.kpje" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>

							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">时间:</div>
								<div class="customerManagementPC-add-customer-li-ipt">

									<el-date-picker v-model="cusUpdateObj.SETTB410CA07" value-format="yyyy-MM-dd">
										type="date"
										placeholder="选择日期">
									</el-date-picker>

								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>


							<!-- <div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">是否冲抵:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<template>
										<el-radio v-model="cusUpdateObj.SETTB411CA03" label="0">不冲抵</el-radio>
										<el-radio v-model="cusUpdateObj.SETTB411CA03" label="1">冲抵</el-radio>
									</template>

								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div> -->
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="cusUpdateServe">保存</el-button>
							<el-button type="info" @click="cusUpdateShow = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="新增冲抵信息" :visible.sync="cdsUpdateShow" width="70%" @close="cdCusClose"
					:closeOnClickModal='false'>
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cdsUpdateObj.SETTB411CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cdsUpdateObj.SETTB411CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>


						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="cdsUpdateObj.SETTB411CA05" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<!-- <div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">冲抵:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />

								<template>
									<el-radio v-model="cdsUpdateObj.SETTB411CA03" label="0">不冲抵</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA03" label="1">冲抵</el-radio>

								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div> -->
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">冲抵类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<!--<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />-->

								<template>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="1">服务费8.5额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="2">服务费8.8额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="4">服务费9.1额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="3">免服务费</el-radio>

								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="cdsUpdateServe">保存</el-button>
							<el-button type="info" @click="cdsUpdateShow = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">

				<el-dialog title="发票审核" :visible.sync="salefpshWaterDetails" width="80%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="userfptj">
							<el-row :gutter="24">
								<el-col :span="6">
									<div class="">
										<span>
											免服务费可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpmf }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											可开总额
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.zxf }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											8.5可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpn }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											8.8可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpw }}</span>
									</div>
								</el-col>

							</el-row>
						</div>
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="fpshtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA07" label="申请时间">
								</el-table-column>
								<el-table-column prop="SETTB410CA01" label="申请人">
								</el-table-column>
								<el-table-column prop="SETTB410CA08" label="申请类型">
									<template slot-scope="scope">
										<p v-if="scope.row.SETTB410CA08 == '1'">
											<span>8.5</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '2'">
											<span>8.8</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '3'">

											<span>免服务费</span>

										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA18" label="申请金额">
								</el-table-column>
								<el-table-column prop="SETTB410CA21" label="服务费金额">
								</el-table-column>

								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA16" label="单位地址">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="电话">
								</el-table-column>
								<el-table-column prop="SETTB410CA15" label="开户银行">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="银行账户">
								</el-table-column>
								<el-table-column prop="SETTB410CA22" label="是否退款">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA22 == '1'">
											<span>是</span>
										</p>
										<p class="public_icon_dayin" v-else>
											<span>否</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA09" label="状态">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA09 == '0'">
											<span>待审核</span>
										</p>
										<p class="public_icon_dayin" v-if="scope.row.SETTB410CA09 == '1'">
											<span>已开票</span>
										</p>
										<p class="public_icon_zuofei" v-if="scope.row.SETTB410CA09 == '2'">
											<span>拒绝</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												v-if="scope.row.SETTB410CA09 == '0' || scope.row.SETTB410CA09 == '2'"
												class="public_icon_dayin public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargefpshbut(scope.row)">上传发票
											</el-button>
											<el-button v-if="scope.row.SETTB410CA09 == '0'"
												class="public_icon_zuofei public_icon_width public_icon_margin"
												type="error" size="small" @click="rechargefpjsbut(scope.row)">拒绝
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="fpshhandleSizeChange" @current-change="fpshhandleCurrentChange"
								:current-page.sync="fpshcurrentPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="fpshdetailsPageLimit" layout="total,sizes, prev, pager, next"
								:total="fpshdetailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">

				<el-dialog title="审核拒绝" :visible.sync="salefpshjjDetails" width="80%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="fpshtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA07" label="申请时间">
								</el-table-column>
								<el-table-column prop="SETTB410CA01" label="申请人">
								</el-table-column>
								<el-table-column prop="SETTB410CA08" label="申请类型">
									<template slot-scope="scope">
										<p v-if="scope.row.SETTB410CA08 == '1'">
											<span>8.5</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '2'">
											<span>8.8</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA18" label="申请金额">
								</el-table-column>

								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA16" label="单位地址">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="电话">
								</el-table-column>
								<el-table-column prop="SETTB410CA15" label="开户银行">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="银行账户">
								</el-table-column>
								<el-table-column prop="SETTB410CA09" label="状态">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA09 == '0'">
											<span>待审核</span>
										</p>
										<p class="public_icon_dayin" v-if="scope.row.SETTB410CA09 == '1'">
											<span>已开票</span>
										</p>
										<p class="public_icon_zuofei" v-if="scope.row.SETTB410CA09 == '2'">
											<span>拒绝</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												v-if="scope.row.SETTB410CA09 == '0' || scope.row.SETTB410CA09 == '2'"
												class="public_icon_dayin public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargefpshbut(scope.row)">上传发票
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="fpshjjhandleSizeChange"
								@current-change="fpshjjhandleCurrentChange" :current-page.sync="fpshjjcurrentPage"
								:page-sizes="[10, 20, 30, 40]" :page-size="fpshjjdetailsPageLimit"
								layout="total,sizes, prev, pager, next" :total="fpshjjdetailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">

				<el-dialog title="详情" :visible.sync="salefpxqWaterDetails" width="90%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="userfptj">
							<el-row :gutter="24">
								<el-col :span="8">
									<div class="">
										<span>
											总额
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.zxf }}</span>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="">
										<span>
											已开
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.zyk }}</span>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="">
										<span>
											未开
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.zkk }}</span>
									</div>
								</el-col>
							</el-row>
						</div>
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="userfpyd.detail" style="width: 100%" stripe
								class="public_tableColumn tableColumn_detail"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="sj" label="月份">
								</el-table-column>
								<el-table-column prop="zxf" label="总额">
								</el-table-column>
								<!-- <el-table-column prop="SETTB410CA08" label="申请类型">
									<template slot-scope="scope">
										<p v-if="scope.row.SETTB410CA08=='1'">
											<span>8.5</span>
										</p>
										<p v-if="scope.row.SETTB410CA08=='2'">
											<span>8.8</span>
										</p>
									</template>
								</el-table-column> -->
								<el-table-column prop="wl" label="物料">
								</el-table-column>

								<el-table-column prop="yf" label="运费">
								</el-table-column>

								<el-table-column label="免费额度" class-name="group-column">
									<el-table-column prop="edmf" label="免费总额" width="90" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="ykpmf" label="免费已开" width="90" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="cdjemf" label="免费冲抵" width="90" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="kkpmf" label="免费未开" width="90" class-name="group-cell">
									</el-table-column>
								</el-table-column>
								<el-table-column label="8.5额度" class-name="group-column">
									<el-table-column prop="edn" label="8.5总额" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="ykpn" label="8.5已开" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="cdjen" label="8.5冲抵" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="kkpn" label="8.5未开" class-name="group-cell">
									</el-table-column>
								</el-table-column>
								<el-table-column label="8.8额度" class-name="group-column">
									<el-table-column prop="edw" label="8.8总额" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="ykpw" label="8.8已开" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="cdjew" label="8.8冲抵" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="kkpw" label="8.8未开" class-name="group-cell">
									</el-table-column>
								</el-table-column>
								<el-table-column label="9.1额度" class-name="group-column group-bottom">
									<el-table-column prop="ed91" label="9.1总额" class-name="group-cell ">
									</el-table-column>
									<el-table-column prop="ykp91" label="9.1已开" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="cdje91" label="9.1冲抵" class-name="group-cell">
									</el-table-column>
									<el-table-column prop="kkp91" label="9.1未开" class-name="group-cell group-bottom">
									</el-table-column>
								</el-table-column>

								<!-- <el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button v-if="scope.row.SETTB410CA09=='0'|| scope.row.SETTB410CA09=='2'" class="public_icon_dayin public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargefpshbut(scope.row)">上传发票
											</el-button>
											<el-button v-if="scope.row.SETTB410CA09=='0'" class="public_icon_zuofei public_icon_width public_icon_margin"
												type="error" size="small" @click="rechargefpjsbut(scope.row)">拒绝
											</el-button>
										</div>
									</template>
								</el-table-column> -->
							</el-table>
						</div>
						<!-- <div class="billOperationRecord-page">
							<el-pagination @size-change="fpshhandleSizeChange" @current-change="fpshhandleCurrentChange"
								:current-page.sync="fpshcurrentPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="fpshdetailsPageLimit" layout="total,sizes, prev, pager, next"
								:total="fpshdetailsCount">
							</el-pagination>
						</div> -->
					</div>
				</el-dialog>
			</div>



			<div class="public-dialog">
				<el-dialog title="开票记录" :visible.sync="saleWaterDetails" width="60%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="tableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA01" label="客户名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="手机号">
								</el-table-column>
								<el-table-column prop="SETTB410CA06" label="开票金额">
								</el-table-column>
								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="账号">
								</el-table-column>
								<el-table-column prop="SETTB410CA07" label="开票时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeTypeModify(scope.row)">修改
											</el-button>
										</div>
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												class="public_icon_xiangqing public_icon_width public_icon_margin"
												type="primary" size="small" @click="ckfp(scope.row.SETTB410CA12)">查看发票
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
								:current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit" layout="total,sizes, prev, pager, next"
								:total="detailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="冲抵记录" :visible.sync="cdleWaterDetails" width="60%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="cdtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB411CA01" label="客户名称">
								</el-table-column>
								<el-table-column prop="SETTB411CA02" label="手机号">
								</el-table-column>
								<el-table-column label="是否冲抵">
									<template slot-scope="scope">{{ scope.row.SETTB411CA03 == '0' ? '不冲抵' : '冲抵'
									}}</template>
								</el-table-column>
								<el-table-column prop="SETTB411CA04" label="金额">
								</el-table-column>
								<el-table-column prop="SETTB411CA08" label="冲抵类型">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">

											<span v-if="scope.row.SETTB411CA08 == '1'">服务费8.5额度</span>
											<span v-if="scope.row.SETTB411CA08 == '2'">服务费8.8额度</span>
											<span v-if="scope.row.SETTB411CA08 == '3'">免服务费</span>

										</div>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB411CA05" label="时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeCdModify(scope.row)">修改
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
								:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit2" layout="total,sizes, prev, pager, next"
								:total="detailsCount2">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="customerManagementAdd" width="30%"
					@close="customerManagementAddName = ''" :closeOnClickModal='false'>
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagementAddName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="customerManagementAddServe">保存</el-button>
							<el-button type="warning" @click="customerManagementAdd = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 客户等级修改 -->
			<div class="public-dialog">
				<el-dialog title="修改开票信息" :visible.sync="customerManagementUpdate" width="30%"
					@close="customerManagemenUPObj = ''" :closeOnClickModal='false'>
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagemenUPObj.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="customerManagementUpdateServe">保存</el-button>
							<el-button type="warning" @click="customerManagementUpdate = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 充值类型新增 rechargeTypeModifyDig-->
			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="rechargeTypeDig" width="30%" @close="rechargeTypeName = ''"
					:closeOnClickModal='false'>
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="rechaTypePreser">保存</el-button>
							<el-button type="warning" @click="rechargeTypeDig = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>

			<!-- 上传发票 -->
			<div class="public-dialog">
				<el-dialog title="上传发票" :visible.sync="rechargefpsh" width="50%" @close="kpmsgClose"
					:closeOnClickModal='false'>

					<div class="">
						<el-upload :class="{ disabled: uploadDisabled }" ref="upload" :auto-upload="false" action=""
							:on-success="handleUploadSuccess" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :on-change="handleChange" :on-exceed="handleExceed"
							:file-list="fileList" :accept="acceptFormat" :limit="limitNum" :multiple="false" drag>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
							<div class="el-upload__tip" slot="tip" style="font-size:20px; color: red;">
								只能上传{{ acceptFormat }}格式的文件，每次上传的文件数量不能超过{{ limitNum }}个</div>
						</el-upload>

					</div>

					<div v-if="fpdialogImageUrl" class="customerManagementPC-add-customer" style="padding-top: 40px;">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="fpsbpdfmsgobj.xftt" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">税号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="fpsbpdfmsgobj.xfsh" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">开票金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="number" v-model="fpsbpdfmsgobj.kpje" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="fpsbpdfmsgobj.kprq" type="date" placeholder="选择日期"
									value-format="yyyy-MM-dd">


								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="rechaTypefpkptj">开票</el-button>
							<el-button type="info" @click="rechargefpsh = false">取消</el-button>
						</div>
					</div>

				</el-dialog>
			</div>

			<!-- 开票记录修改 -->
			<div class="public-dialog">
				<el-dialog title="修改开票记录" :visible.sync="rechargeTypeModifyDig" width="30%"
					@close="rechargeTypeModifyClose" :closeOnClickModal='false'>
					<!-- <div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeUpOBJ.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
							<el-button type="warning" @click="rechargeTypeModifyDig=false">取消</el-button>
						</div>
					</div> -->

					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeTypeUpOBJ.SETTB410CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeTypeUpOBJ.SETTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">抬头:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA03" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">税号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">账号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA05" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA06" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="rechargeTypeUpOBJ.SETTB410CA07" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
							<el-button type="info" @click="rechargeTypeModifyDig = false">取消</el-button>
						</div>
					</div>

				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="修改冲抵记录" :visible.sync="rechargeCdModifyDig" width="70%"
					@close="rechargeTypeModifyClose" :closeOnClickModal='false'>
					<div class="customerManagementPC-add-customer">

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeCdUpOBJ.SETTB411CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeCdUpOBJ.SETTB411CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeCdUpOBJ.SETTB411CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="rechargeCdUpOBJ.SETTB411CA05" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<!-- 	<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">是否冲抵:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />

								<template>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA03" label="0">不冲抵</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA03" label="1">冲抵</el-radio>
								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div> -->
						<div class="customerManagementPC-add-customer-li" v-if="rechargeCdUpOBJ.SETTB411CA03 == '1'">
							<div class="customerManagementPC-add-customer-li-name">冲抵类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<template>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="1">服务费8.5额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="2">服务费8.8额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="4">服务费9.1额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="3">免服务费</el-radio>
								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="rechCdPreserModify">保存</el-button>
							<el-button type="info" @click="rechargeCdModifyDig = false">取消</el-button>
						</div>
					</div>

				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="变动记录" :visible.sync="deductionRecord" width="70%"
					@close="ORMTB411ID = '', deductionRecordPage = 1, deductionRecordLimit = 10, deductionRecordCount = 0"
					:closeOnClickModal='false'>
					<el-table :data="deductionRecordtable" style="width: 100%" stripe class="public_tableColumn"
						:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
						<el-table-column prop="ORMTB413CA01" label="扣费时间">
						</el-table-column>
						<el-table-column prop="ORMTB440CA00" label="派单号">
						</el-table-column>
						<el-table-column prop="ORMTB413CA00" label="扣款金额">
						</el-table-column>
						<el-table-column prop="ORMTB413CA02" label="变动类型">
						</el-table-column>
						<!-- <el-table-column prop="" label="扣后金额">
						</el-table-column> -->
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.ORMTB413CA02 != '红冲'"
									class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
									size="small" @click="DetailsWaterClick(scope.row)" id="详情">详情</el-button>
							</template>

						</el-table-column>
					</el-table>
					<div class="billOperationRecord-page">
						<el-pagination @size-change="deductionRecordSizeChange"
							@current-change="deductionRecordCurrentChange" :current-page.sync="deductionRecordPage"
							:page-sizes="[10, 20, 30, 40]" :page-size="deductionRecordLimit"
							layout="total,sizes, prev, pager, next" :total="deductionRecordCount">
						</el-pagination>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="详情" :visible.sync="DetailsWater" width="30%" :closeOnClickModal='false'>
					<div class="DetailsWater-Dialog">
						<div class="DWD-li">
							<div class="DWD-li-title">流水号</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA00 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">企业名称</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA05 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">客户名称</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA03 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">车牌号</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA01 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">派单时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA19 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">结算时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CC00 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">回执时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CE00 || '' }}</div>
						</div>
						<div class="DWD-table">
							<div class="DWD-table-left-title">
								<div></div>
								<div>派单</div>
								<div>结算</div>
								<div>回执</div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料</div>
								<div>{{ deductionRecordObj.ORMTB440CA07 || '' }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC02 || '' }}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>重量</div>
								<div>{{ deductionRecordObj.ORMTB440CA10 || 0 }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC04 || 0 }}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01 == '5'">{{ deductionRecordObj.ORMTB440CE09 ||
									0 }}
								</div>
								<div v-else></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料金额</div>
								<div>{{ deductionRecordObj.ORMTB440CA11 || 0 }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC06 || 0 }}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>运费金额</div>
								<div>{{ deductionRecordObj.ORMTB440CA12 || 0 }}</div>
								<div>{{ deductionRecordObj.jsORMTB440CA12 || 0 }}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01 == '5'">{{ deductionRecordObj.ORMTB440CE10 ||
									0 }}
								</div>
								<div v-else></div>
							</div>
						</div>
					</div>
					<div class="DetailsWater-img">
						<div class="DetailsWater-img-text">回执记录</div>
						<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
							:preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import {
	Decimal
} from 'decimal.js';
export default {
	data() {
		return {
			customerManagementList: '',
			customerManagementValue: '',
			customerManagement: false,
			customerManagementAdd: false,
			customerManagementAddName: '',
			customerManagemenUPObj: '',
			customerManagementUpdate: false,
			cusQueryName: '',
			cusQueryTime: this.getCurrentMonthFirstDay(),
			cusQueryiphone: '',
			options: [],
			cusStatus: '',
			cusStatusList: [],
			tableData: [],
			flag: '',
			page: 1,
			pagesize: 10,
			currentPage: 1,
			count: 0,
			currentPage1: 1,
			detailsPageLimit: 10,
			detailsCount: 1,
			currentPage2: 1,
			detailsPageLimit2: 10,
			detailsCount2: 1,
			RechargetypeValue: '银行卡',
			RechargetypeOptions: [],
			CZRecordsDetails: [],
			CZRecordsPage: 1,
			CZRecordsPageLimit: 10,
			CZRecordsCount: 0,
			tableDataDetails: [],
			cdtableDataDetails: [],
			offerDetailsTab: [],
			ORMTB411ID: '',
			CustomerfillingDig: false,
			wayTypeValue: '',
			wayTypeOptions: [{
				value: 'CW',
				label: '财务'
			},
			{
				value: 'XX',
				label: '线下'
			},
			{
				value: 'XS',
				label: '线上'
			},
			],
			khdj: '',
			khdjOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '0301',
				label: '一级客户',
			}, {
				value: '0302',
				label: '二级客户',
			}, {
				value: '0303',
				label: '三级客户',
			}, {
				value: '0304',
				label: '四级客户',
			}, {
				value: '0305',
				label: '五级客户',
			}, {
				value: '0306',
				label: '六级客户',
			}, {
				value: '0307',
				label: '七级客户',
			}, {
				value: '0308',
				label: '八级客户',
			},
			{
				value: '0309',
				label: '九级客户',
			}
			],
			khxj: '',
			khxjOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '1',
				label: 'V1',
			}, {
				value: '2',
				label: 'V2',
			}, {
				value: '3',
				label: 'V3',
			}, {
				value: '4',
				label: 'V4',
			}, {
				value: '5',
				label: 'V5',
			}],
			kpedlx: [{
				value: '1',
				label: '服务费8.5额度'
			}, {
				value: '2',
				label: '服务费8.8额度'
			}, {
				value: '3',
				label: '额度免费'
			}],
			kpedlxValue: '1',
			CZmoney: '',
			Czmaxlength: 10, //充值限额
			CZremark: '',
			HCmoney: '',
			HCremark: '',
			HCamountCapitalText: '',
			amountCapitalText: '',
			cusInsertShow: false,
			cusInsertObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			cusUpdateShow: false,
			cusUpdateObj: {
				ORMTB410ID: '',
				ORMTB410CA00: '',
				SETTB410CA01: '',
				ORMTB410CA02: '',
				SETTB410CA03: '',
				SETTB410CA04: '',
				SETTB410CA05: '',
				SETTB410CA06: '',
				SETTB410CA07: '',
				SETTB411CA03: '1'


			},
			cdsUpdateShow: false,
			cdsUpdateObj: {
				ORMTB410ID: '',
				SETTB411CA00: '',
				SETTB411CA01: '',
				SETTB411CA02: '',
				SETTB411CA03: '1',
				SETTB411CA04: '',
				SETTB411CA05: ''
			},
			cusDJSetObj: {},
			freezeInsertShow: false,
			saleWaterDetails: false,

			cdleWaterDetails: false,
			rechargeTypeDig: false,
			rechargeTypeName: '',
			rechargeTypeUpOBJ: {
				SETTB206CA01: ''
			},
			rechargeTypeModifyDig: false,
			rechargeCdModifyDig: false,
			rechargeCdUpOBJ: {
				SETTB206CA01: '',
				SETTB411CA08: ''
			},
			czRechargetypeShow: false,
			HCshow: false,
			HCObj: '',
			preferentialRecord: false,
			offerDetails: false,
			DetailsWater: false,
			deductionRecord: false,
			deductionRecordObj: '',
			deductionRecordtable: [],
			deductionRecordPage: 1,
			deductionRecordLimit: 10,
			deductionRecordCount: 0,
			DetailsWaterurl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
			DetailsWatersrcList: [
				'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
				'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
			],
			preferentialType: 0,
			solelist: [],
			cusUDJSetpdateShow: false,
			tableDataGradePre: [],
			innerVisible: false,
			// 发票审核START
			fpshcurrentPage: 1,
			fpshdetailsPageLimit: 10,
			fpshdetailsCount: 1,

			fpshjjcurrentPage: 1,
			fpshjjdetailsPageLimit: 10,
			fpshjjdetailsCount: 1,

			salefpshWaterDetails: false,
			salefpshjjDetails: false,
			salefpxqWaterDetails: false,
			rechargefpsh: false,
			fpshtableDataDetails: [],
			userfpyd: {},
			// 发票审核END

			//发票上传START
			uploadUrl: '/api/upload', // 文件上传地址
			fileList: [], // 已上传的文件列表
			acceptFormat: '.pdf', // 支持上传的文件格式
			limitNum: 1, // 限制每次上传的文件数量
			maxSize: 20, // 限制文件的最大大小（MB）
			fpdialogImageUrl: '', //票据URL
			downloadUrl: '/api/download', // 文件下载地址
			fpsqobj: {},
			fpsbpdfmsgobj: {

			},
			addimg: [],
			formdata: new FormData(),
			//发票上传END
			zyk: '',
			zed: ''
		};
	},
	created() {
		var list = "";
		if (this.$route.query.mark != "" && this.$route.query.mark != null) {
			this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
			list = JSON.parse(sessionStorage.getItem("qpSolelist"));
			sessionStorage.removeItem('qpUobj');
			sessionStorage.removeItem('qpSolelist');
			this.quanpDisabled = true;
		} else {
			this.userobj = this.$store.state.uobj;
			list = this.$store.state.solelist;
			this.quanpDisabled = false;
		}
		var path = this.$route.path;
		if (path === "/saleCustomerInvoice") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		console.log(this.solelist);

		// console.log(this.solelist)
		// 赋值，缓存销毁
		// this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		// sessionStorage.removeItem(this.currentUrl);
		let queryObj = JSON.parse(sessionStorage.getItem('queryObj'));
		if (queryObj) {
			this.init(queryObj);
		}
		// console.log(this.solelist)
		this.wayTypeValue = this.wayTypeOptions[0].value
	},
	computed: {
		// 计算属性返回当月的一号日期
		uploadDisabled: function () {
			// console.log(this.ruleForm.csAvatar)
			return this.fpdialogImageUrl != '';
		},
	},
	watch: {
	    cusQueryName: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: '',
					cusQueryiphone: this.cusQueryiphone,
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: this.khdj,
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
		cusQueryiphone: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: this.cusQueryName,
					cusQueryiphone: '',
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: this.khdj,
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
		khdj: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: this.cusQueryName,
					cusQueryiphone: this.cusQueryiphone,
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: '',
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
	},
	mounted() {
		// this.firstDayOfMonth()
		this.querycusList()
		this.getCurrentMonthFirstDay()
		// this.querypreferentialCode()
	},
	// 存储数据
	// beforeDestroy() {
	// 	var obj = {
	// 		cusQueryName: this.cusQueryName, //客户名称
	// 		// cusQueryTime: this.cusQueryTime, //客户名称
	// 		cusQueryiphone: this.cusQueryiphone, //客户名称
	// 		cusStatus: this.cusStatus, //客户状态
	// 		currentPage: this.currentPage, //当前页数
	// 		page: this.page, //页码
	// 		pagesize: this.pagesize, //每页条数,
	// 		khdj: this.khdj, //客户等级
	// 	};
	// 	sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	// },
	beforeRouteLeave(to, from, next) {
		const obj = {
			cusQueryName: this.cusQueryName,
			cusQueryiphone: this.cusQueryiphone,
			cusStatus: this.cusStatus,
			currentPage: this.currentPage,
			page: this.page,
			pagesize: this.pagesize,
			khdj: this.khdj,
		};
		sessionStorage.setItem('queryObj', JSON.stringify(obj));
		next();
	},
	methods: {

		onSortChange({
			prop,
			order
		}) {
			// console.log(order)
			if (prop == 'ORMTB410CA06') {
				this.tableData.sort(this.compare(prop, order));
			}

		},

		//预览
		handlePictureCardPreview(file) {
			// this.dialogImageUrl = file.url;
			console.log(file)
			// this.dialogVisible = true;
		},
		handleChange(file, fileList) {

			console.log(fileList);
			this.addimg = fileList[0].raw;
			this.fileList = []
			const formData = new FormData();
			formData.append("file", this.addimg);
			// formData.append('ORMTB470CA00', this.ORMTB470CA00)
			let loading = this.$loading({
				lock: true,
				text: '上传中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/system/uploadBD";

			this.axios.post(url, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					console.log(res)
					this.$message({
						message: res.data.data.message,
						type: 'success'
					});
					// this.fileList.push({
					// 	name: param.file.name,
					// 	url: res.data.data.bdurl,
					// 	uid: param.file.uid,
					// });
					this.fpdialogImageUrl = res.data.data.bdurl

					this.fileList = fileList


					this.hdPDFsb()

					// this.bdurlList.push(res.data.data.bdurl)
					// this.dialogVisible = true
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})

			//   console.log(file);
		},
		//控制上传数量提示
		handleExceed(files, fileList) {
			this.$message.warning(`最多上传1个文件`);
		},
		// 删除
		handleRemove(file, fileList) {
			console.log(file)

			console.log(fileList)

			return;

			var index1 = this.fpdialogImageUrl.lastIndexOf("2022", "2023")
			var imgdel = this.fpdialogImageUrl.substring(index1)
			// console.log(imgdel)
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/orm/ormtb440/deleteFile";
			var postData = {
				fileName: imgdel
			}
			this.axios.post(url, postData).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					// console.log(res)
					this.fpdialogImageUrl = '';
					this.fpsbpdfmsgobj = {}
					this.formdata = new FormData();
					this.$message({
						message: res.data.message,
						type: 'success'
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})


		},
		hdPDFsb() {

			var url = "/set/settb410Entity/recog"
			var postData = {
				SETTB410CA12: this.fpdialogImageUrl
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					console.log(res)
					this.fpsbpdfmsgobj = res.data.data
					// this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})

		},

		// 文件上传成功后的回调函数
		handleUploadSuccess(response, file, fileList) {

		},


		getCurrentMonthFirstDay() {
			// const now = new Date();
			// const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

			// console.log(new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0])
			// return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];

			var date = new Date() // this.startTime = '2022-5-02'
			var new_year = date.getFullYear() // 取当前的年份
			var month = date.getMonth()
			var new_month = month + 1 // 取当前的月份
			if (month > 12) {
				new_month -= 12 // 月份减
				new_year++ // 年份增
			}
			var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
			var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
			if (firstDay.getMonth() < 10) {
				var mon = "0" + firstDay.getMonth()
			} else {
				var mon = firstDay.getMonth()
			}
			var startDate = firstDay.getFullYear() + '-' + mon + '-' + "0" + firstDay.getDate();
			var endDate = firstDay.getFullYear() + '-' + mon + '-' + lastDay;
			return startDate
			// console.log(startDate)

			// 最后输出 2022-5-01  2022-5-31

		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName];
				var value2 = obj2[propertyName];
				// console.log(value2)

				if (typeof value1 === "string" && typeof value2 === "string") {
					const res = value1.localeCompare(value2);
					return sort === "ascending" ? res : -res;
				} else {
					// if (value1 <= value2) {
					// 	return sort === "ascending" ? -1 : 1;
					// } else if (value1 > value2) {
					// 	return sort === "ascending" ? 1 : -1;
					// }
				}
			};
		},


		// 账号的启用和禁用
		updateUserStatus(item) {
			var url = "/orm/ormtb410/updateUserStatus"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				ORMTB410CA02: item.ORMTB410CA02, // 手机号
				ORMTB410CB00: item.ORMTB410CB00 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 账号的启用和禁用
		updateYfStatus(item) {
			var url = "/orm/ormtb410/updateORMTB410CB10"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				ORMTB410CB10: item.ORMTB410CB10 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 下单的限制和解除限制
		updateUserLimitStatus(item) {
			var url = "/orm/ormtb410/updateORMTB410CB01"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				// ORMTB410CA02: item.ORMTB410CA02, // 手机号
				ORMTB410CB01: item.ORMTB410CB01 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		//初始化数据
		init(data) {
			this.cusQueryName = data.cusQueryName;
			// this.cusQueryTime = this.historyInfo.cusQueryTime;
			this.cusQueryiphone = data.cusQueryiphone;
			this.currentPage = data.currentPage;
			this.page = data.page;
			this.pagesize = data.pagesize;
			this.cusStatus = data.cusStatus;
			this.khdj = data.khdj;
		},
		fullScreen() {
			//全屏
			var mark = 1;
			sessionStorage.setItem(
				"qpSolelist",
				JSON.stringify(this.$store.state.solelist)
			);
			sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

			let Logistics = this.$router.resolve({
				path: "/SalesCustomer",
				query: {
					mark: mark,
				},
			});
			this.$baseAPI.requestFullScreen(Logistics);
		},
		querycusList(dataFlag) {
			if (!this.cusQueryTime) {
				this.$message.error('请选择时间')
				return;
			}

			this.tableData = []
			this.flag = dataFlag
			// this.count =0
			var url = "/set/settb410/selectPageList"
			if (dataFlag) {
				this.page = ''
				this.pagesize = ''
			}
			var postData = {
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
				ORMTB410CA00: this.cusQueryName, //客户名称
				TIME: this.cusQueryTime, //时间
				ORMTB410CA02: this.cusQueryiphone, //客户手机号
				ORMTB410CA06: this.khdj, //客户等级
				flag: dataFlag, //查询所有客户全部展示
				page: this.page,
				limit: this.pagesize
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				console.log(res)
				if (res.data.code == 200) {
					this.tableData = res.data.data.fpData;
					console.log(res.data)
					this.count = res.data.count;
					this.zed = res.data.data.zed
					this.zyk = res.data.data.zyk

				}
				if (this.tableData.length > 0) {
					setTimeout(() => {
						loading.close()
					}, 300)
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)

			}).catch(() => {
				loading.close()
			})
		},
		freezeSetClick() {
			this.freezeInsertShow = true
			this.cusSelect()
		},
		cusSelect() {
			var url = "/orm/ormtb405/select"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataGradePre = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.querycusList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.querycusList();
		},

		fpshhandleSizeChange(val) { //发票审核-分页

			this.fpshdetailsPageLimit = val;
			this.fpshcurrentPage = 1;
			console.log(this.cusUpdateObj)

			this.queryfpsheQuery(0)

		},
		fpshhandleCurrentChange(val) { //发票审核-分页
			// this.fpshcurrentPage = 1;
			this.queryfpsheQuery(0)
		},

		fpshjjhandleSizeChange(val) { //发票审核拒绝-分页

			this.fpshjjdetailsPageLimit = val;
			this.fpshjjcurrentPage = 1;
			this.queryfpsheQuery(2)

		},
		fpshjjhandleCurrentChange(val) { //发票审核拒绝-分页
			// this.fpshjjcurrentPage = 1;
			this.queryfpsheQuery(2)
		},



		offerDetailsClick(row) {
			this.offerDetails = true
			this.offerDetailsTab = []
			var url = "/orm/ormtb412/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB411ID: row.ORMTB411ID,
				SETTB206CD01: this.userobj.pertb005.pertb005cd01,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.offerDetailsTab = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordClick(row) {
			// console.log(row)
			this.deductionRecordtable = []
			// this.deductionRecordCount=0
			var url = "/orm/ormtb413/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.ORMTB411ID = row.ORMTB411ID
			var postData = {
				ORMTB411ID: this.ORMTB411ID,
				page: this.deductionRecordPage,
				limit: this.deductionRecordLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordtable = res.data.data;
					this.deductionRecordCount = res.data.count
					this.deductionRecordtable.forEach(item => {
						if (item.ORMTB413CA02 == 'KK') {
							item.ORMTB413CA02Text = "扣款"
						} else if (item.ORMTB413CA02 == 'TK') {
							item.ORMTB413CA02Text = "退款"
						}
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordSizeChange(val) {
			this.deductionRecordLimit = val;
			this.deductionRecordPage = 1;
			this.deductionRecordClick();
		},
		deductionRecordCurrentChange(val) {
			this.deductionRecordPage = val;
			this.deductionRecordClick();
		},
		queryWayTypeQuery() {
			this.tableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb410/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				page: this.currentPage1,
				limit: this.detailsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataDetails = res.data.data;
					this.detailsCount = res.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		queryfpsheQuery(data) { //发票审核
			this.fpshtableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb410Entity/settb410ListAdmin"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			let pag
			let limit
			if (this.salefpshWaterDetails) {
				pag = this.fpshcurrentPage;
				limit = this.fpshdetailsPageLimit
			}
			if (this.salefpshjjDetails) {
				pag = this.fpshjjcurrentPage;
				limit = this.fpshjjdetailsPageLimit
			}

			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				SETTB410CA09: data,
				page: pag,
				limit: limit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				console.log(this.cusUpdateObj.ORMTB410ID)
				if (res.data.code == 200) {
					this.fpshtableDataDetails = res.data.data.list;
					this.fpshdetailsCount = res.data.data.total;
					this.fpshjjdetailsCount = res.data.data.total;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		queryCdWayTypeQuery() {
			this.cdtableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb411/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB411CA00: this.cdsUpdateObj.ORMTB410ID,
				page: this.currentPage2,
				limit: this.detailsPageLimit2
			}
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.cdtableDataDetails = res.data.data.data;
					console.log(res)
					this.detailsCount2 = res.data.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange1(val) {
			this.detailsPageLimit = val;
			this.currentPage1 = 1;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleSizeChange2(val) {
			this.detailsPageLimit2 = val;
			this.currentPage2 = 1;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleCurrentChange2(val) {
			this.currentPage2 = val;
			// this.deductionRecordClick();
			this.queryCdWayTypeQuery()
		},
		saleWaterDetailsclose() {

		},
		CustomerfillingDigClose() {

		},
		cusInsertClose() {
			this.cusInsertObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
		},
		cusInsertServe() {
			if (this.cusInsertObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
			var reQ = /^1[3-9][0-9]{9}$/;
			if (!reQ.test(this.cusInsertObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
			if (this.preferentialType == 1) {
				if (this.cusInsertObj.ORMTB410CA06.length == 0) {
					return this.$message.error('请选择客户等级')
				}
			}
			var url = "/orm/ormtb410/insertOrmtb410"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cusInsertObj
			postData.ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.querycusList()
					this.cusInsertShow = false
					this.cusInsertObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: '',
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusDJSetInsertServe() {
			var url = "/orm/ormtb405/update"
			var settb400List = []

			this.tableDataGradePre.forEach((resitme) => {
				settb400List.push(resitme)

			})
			var postData = {
				list: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.freezeInsertShow = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// upCusClose() {
		// 	this.cusUpdateObj = {
		// 		ORMTB400ID: '',
		// 		ORMTB410CA00: '',
		// 		ORMTB410CA01: '',
		// 		ORMTB410CA02: '',
		// 		ORMTB410CA06: ''
		// 	}
		// 	this.CZmoney = ''
		// 	this.wayTypeValue = 'CW'
		// 	this.amountCapitalText = ''
		// },

		kpmsgClose() {
			this.fpsbpdfmsgobj = {}
			this.fpdialogImageUrl = ''
			this.cusUpdateObj = {}
			this.$refs.upload.clearFiles();
		},

		cdCusClose() {
			this.cdsUpdateObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
			this.CZmoney = ''
			this.wayTypeValue = 'CW'
			this.amountCapitalText = ''
		},


		innerVisibleClick() {
			if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
			if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
			if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')

			if (!this.CZremark) {
				this.$message.error('请填写备注')
			} else {
				this.innerVisible = true
			}
		},




		upuserClick(row) {
			this.cusUpdateShow = true
			var str = JSON.stringify(row)
			console.log(str)
			this.cusUpdateObj = JSON.parse(str)
		},
		cduserClick(row) {
			this.cdsUpdateShow = true
			this.cdsUpdateObj.ORMTB410ID = row.ORMTB410ID
			this.cdsUpdateObj.SETTB411CA00 = row.ORMTB410ID
			this.cdsUpdateObj.SETTB411CA01 = row.ORMTB410CA00
			this.cdsUpdateObj.SETTB411CA02 = row.ORMTB410CA02
			this.cdsUpdateObj.SETTB411CA03 = '1'
		},
		xquserClick(row) {
			this.salefpxqWaterDetails = true
			this.userfpydmsg(row)

		},
		kpjlialClick(row) {
			this.saleWaterDetails = true
			this.cusUpdateObj.ORMTB410ID = row.ORMTB410ID
			this.queryWayTypeQuery()
		},
		fpshjlialClick(row) {
			this.cusUpdateObj = row
			console.log(this.cusUpdateObj)
			this.salefpshWaterDetails = true
			this.queryfpsheQuery(0)
			// this.userfpydmsg(row)
		},
		fpshjjjlialClick(row) {
			this.cusUpdateObj = row
			console.log(this.cusUpdateObj)
			this.salefpshjjDetails = true
			this.queryfpsheQuery(2)
		},

		cdjlialClick(row) {
			this.cdleWaterDetails = true
			this.cdsUpdateObj.ORMTB410ID = row.ORMTB410ID
			this.queryCdWayTypeQuery()
		},
		upDJSetuserClick(row) {
			this.cusUDJSetpdateShow = true
			var str = JSON.stringify(row)
			this.cusDJSetObj = JSON.parse(str)
			// console.log(this.cusDJSetObj)
		},
		cusADD() {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusInsertShow = true
		},
		kpjlQuer() {
			var url = "/set/settb410/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {


				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		userfpydmsg(data) {
			var url = "/set/settb410Entity/selectKPDataAdmin"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: data.ORMTB410ID

			}
			this.axios.post(url, postData).then(res => {
				console.log(res)

				if (res.data.code == 200) {

					this.userfpyd = res.data.data
					// this.cusUpdateObj = res.data.data
					console.log(res)

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdateServe() {//保存冲抵信息

			if (!this.fpsbpdfmsgobj.xftt) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.fpsbpdfmsgobj.xfsh) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.cusUpdateObj.SETTB410CA05) {
				this.$message.error('请输入账号')
				return;
			}
			if (!this.fpsbpdfmsgobj.kpje) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.cusUpdateObj.SETTB411CA03) {
				this.$message.error('请选择是否冲抵')
				return;
			}
			if (!this.cusUpdateObj.SETTB410CA07) {
				this.$message.error('请输入时间')
				return;
			}


			var url = "/set/settb410/insert"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				SETTB410CA01: this.cusUpdateObj.ORMTB410CA00,
				SETTB410CA02: this.cusUpdateObj.ORMTB410CA02,
				SETTB410CA03: this.fpsbpdfmsgobj.xftt, //抬头
				SETTB410CA04: this.fpsbpdfmsgobj.xfsh, //税号
				SETTB410CA05: this.cusUpdateObj.SETTB410CA05,
				SETTB410CA06: this.fpsbpdfmsgobj.kpje, //开票金额
				SETTB410CA07: this.cusUpdateObj.SETTB410CA07,
				SETTB410CA08: this.kpedlxValue

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('成功')
					this.querycusList()
					this.cusUpdateShow = false
					this.$refs.upload.clearFiles()
					this.cusUpdateObj = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cdsUpdateServe() {
			// if (!this.cdsUpdateObj.SETTB411CA03) {
			// 	this.$message.error('请选择是否冲抵')
			// 	return;
			// }
			if (!this.cdsUpdateObj.SETTB411CA04) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.cdsUpdateObj.SETTB411CA05) {
				this.$message.error('请输入时间')
				return;
			}
			console.log(this.cdsUpdateObj)
			var url = "/set/settb411/insert"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cdsUpdateObj
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.$message.success('成功')
					this.querycusList()
					this.cdsUpdateShow = false
					this.cdsUpdateObj = {
						ORMTB410ID: '',
						SETTB411CA00: '',
						SETTB411CA01: '',
						SETTB411CA02: '',
						SETTB411CA04: '',
						SETTB411CA05: ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		rechargeTypeModify(row) {
			this.rechargeTypeModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeTypeUpOBJ = JSON.parse(str)
		},
		ckfp(data) {

			// console.log(data)
			if (!data) {
				this.$message({
					message: '没有可查看的发票',
					type: 'error'
				});
				return;
			} else {
				window.open(data, '_blank')
			}




		},
		rechargefpshbut(row) {
			this.rechargefpsh = true
			this.fpsqobj = row
		},
		rechargefpjsbut(row) {
			console.log(row)
			var url = "/set/settb410Entity/settb410AuditAdmin";
			this.$prompt('请输入拒绝原因', '提示', {
				confirmButtonText: '拒绝',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputErrorMessage: '原因不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					SETTB410ID: row.SETTB410ID,
					SETTB410CA09: '2', //状态
					SETTB410CA11: value, //取消原因
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.pageList()
						this.$message({
							type: 'success',
							message: '拒绝成功!'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					loading.close();
				}).catch(() => {
					loading.close();
				})
			})
		},
		rechargeCdModify(row) {
			this.rechargeCdModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeCdUpOBJ = JSON.parse(str)
		},
		disableCus(row, type) {
			var str = type == 1 ? '启用' : '禁用'
			this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: '',
					SETTB206ID: row.SETTB206ID,
					SETTB206CA02: type,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`${str}成功`)
						this.queryWayTypeQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},
		rechargeTypeAdd() {
			this.rechargeTypeDig = true
		},
		rechargeTypeModifyClose() {
			this.rechargeTypeUpOBJ = {
				SETTB206CA01: ''
			}
		},
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "02", //默认02
				"SETTB206CA00": "0202", //代码值默认0202
				"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data[0].SETTB206CA02
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementQuery() {
			this.customerManagementList = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerManagementList = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementAddServe() {
			if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/insertVIP "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.customerManagementAddName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.customerManagementQuery()
					this.customerManagementAdd = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdataClick(row) {
			this.customerManagemenUPObj = row
			this.customerManagementUpdate = true
		},
		customerManagementUpdateServe() {
			if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01) return this.$message
				.error('请修改名称')
			if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/updateVIP"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
				SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.customerManagementQuery()
					this.customerManagementUpdate = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreser() {
			if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/addCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.queryWayTypeQuery()
					this.rechargeTypeDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreserModify() {

			if (!this.rechargeTypeUpOBJ.SETTB410CA03) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA04) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA05) {
				this.$message.error('请输入账号')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA06) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA07) {
				this.$message.error('请输入时间')
				return;
			}

			var url = "/set/settb410/update"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB410ID: this.rechargeTypeUpOBJ.SETTB410ID,
				SETTB410CA01: this.rechargeTypeUpOBJ.SETTB410CA01,
				SETTB410CA02: this.rechargeTypeUpOBJ.SETTB410CA02,
				SETTB410CA03: this.rechargeTypeUpOBJ.SETTB410CA03,
				SETTB410CA04: this.rechargeTypeUpOBJ.SETTB410CA04,
				SETTB410CA05: this.rechargeTypeUpOBJ.SETTB410CA05,
				SETTB410CA06: this.rechargeTypeUpOBJ.SETTB410CA06,
				SETTB410CA07: this.rechargeTypeUpOBJ.SETTB410CA07,

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryWayTypeQuery()
					this.rechargeTypeModifyDig = false

					this.rechargeTypeUpOBJ = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
					}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},


		rechaTypefpkptj() {
			// this.handleRemove()
			if (!this.fpsbpdfmsgobj.xftt) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.fpsbpdfmsgobj.xfsh) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.fpsbpdfmsgobj.kpje) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.fpsbpdfmsgobj.kprq) {
				this.$message.error('请输入时间')
				return;
			}

			var url = "/set/settb410Entity/settb410AuditAdmin"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			console.log(this.cusUpdateObj)
			var postData = {
				SETTB410CA17: this.fpsbpdfmsgobj.xftt,
				SETTB410ID: this.fpsqobj.SETTB410ID,
				SETTB410CA09: '1',
				SETTB410CA12: this.fpdialogImageUrl,
				SETTB410CA06: this.fpsbpdfmsgobj.kpje,
				SETTB410CA07: this.fpsbpdfmsgobj.kprq
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$refs.upload.clearFiles()
					this.$message.success('开票成功')
					if (this.salefpshjjDetails) {
						this.queryfpsheQuery(2)
					}
					if (this.salefpshWaterDetails) {
						this.queryfpsheQuery(0)
					}

					this.rechargefpsh = false
					this.cusUpdateObj = {}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		rechCdPreserModify() {

			// if (!this.rechargeCdUpOBJ.SETTB411CA03) {
			// 	this.$message.error('请选择是否冲抵')
			// 	return;
			// }
			if (!this.rechargeCdUpOBJ.SETTB411CA04) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.rechargeCdUpOBJ.SETTB411CA05) {
				this.$message.error('请输入时间')
				return;
			}
			var url = "/set/settb411/update"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			console.log(this.rechargeCdUpOBJ)
			var postData = this.rechargeCdUpOBJ
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryCdWayTypeQuery()
					this.rechargeCdModifyDig = false

					this.rechargeCdUpOBJ = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						// SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
						SETTB411CA08: ''
					}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})


		},
		DetailsWaterClick(item) {
			// console.log(item)
			if (!item.ORMTB440CA00) {
				this.$message({
					message: '未查询到订单',
					type: 'error'
				});
				return
			}
			this.DetailsWater = true
			this.deductionRecordDetileQuery(item)
		},
		deductionRecordDetileQuery(row) {
			this.deductionRecordObj = ''
			this.DetailsWatersrcList = []
			this.DetailsWaterurl = ''
			var url = "/orm/ormtb440/selectDetails"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				ORMTB440ID: row.ORMTB413CA03,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordObj = res.data.data
					this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
					this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		}



	}
};
</script>

<style scoped>
.carDialogTitle {
	font-weight: bold;
	line-height: 60px;
	color: rgb(0, 163, 255);
}

.customerManagementPC {
	background-color: #f3f3f3;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 100px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
	margin-left: 0;
}

.customerManagementPC-btn {
	text-align: left;
	margin-bottom: 20px;
}

.customerManagementPC-btn i {
	margin-right: 10px;
}

.customerManagementPC-table {
	padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
	font-size: 12px;
	margin-right: 5px;
}

.customerManagementPC-add-customer {
	padding-left: 20px;
}

.customerManagementPC-add-customer-li {
	display: flex;
	text-align: center;
	font-size: 16px;
	height: 42px;
	line-height: 42px;
}

.customerManagementPC-add-customer-li>div {
	border: 1px solid #cdcdcd;
	border-top: none;
}

.customerManagementPC-add-customer-li:first-child>div {
	border-top: 1px solid #cdcdcd;
}

.customerManagementPC-add-customer-li>div:first-child {
	border-right: none;
}

.customerManagementPC-add-customer-li>div:last-child {
	border: none;
	color: #ff4d35;
}

.customerManagementPC-add-customer-li-name {
	flex: 1;
}

.customerManagementPC-add-customer-li-ipt {
	flex: 1;
	box-sizing: border-box;
}

.customerManagementPC-add-customer-li-ipt input {
	border: none;
	outline: none;
	width: 100%;
	height: 37px;
	box-sizing: border-box;
	vertical-align: top;
	padding-left: 5px;
	text-align: center;
	font-size: 16px;
}

.customerManagementPC-add-customer-li-type {
	flex: 0.3;
}

.customerManagementPC-add-customer-btn {
	text-align: center;
	margin: 30px 0 20px 0;
}

.public-chech-details-table {
	margin-top: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.public-chech-details-table-no-text {
	line-height: 80px;
	text-align: center;
	border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
	margin-top: 20px;
	text-align: right;
}

.CustomerfillingDig-priceNumtext {
	font-weight: 500;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 0 20px 10px;
	color: #333;
}

.CustomerfillingDig-priceNumtext span {
	color: rgba(175, 181, 4, 1.0);
	margin-left: 10px;
	font-size: 20px;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord-border {

	/* border-top: 2px solid rgba(205,205,205,.4); */
	border-top: none;
	box-sizing: border-box;
	margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center;
}

.customerRecharge-table {
	box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
	border-color: rgba(254, 172, 0, 1) !important;
}

.CustomerfillingDig-tab {
	padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
	display: flex;
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 16px;
	color: #333;
	vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
	border: 1px solid #CDCDCD;
	border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
	border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
	border: none;
	color: #FF4D35;
}

.CustomerfillingDig-tab-li-text {
	flex: .8;
	background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
	flex: .8;
}

.rechargeType-tab-li-text {
	flex: .35;
}

.rechargeType-tab-li-ipt {
	flex: .7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
	height: 46px;
	width: 100%;

	text-align: center;

	box-sizing: border-box;
	font-size: 16px;
	color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
	outline: none;
	border: none;
	vertical-align: top;
}

.rechargeType-tab-li-ipt input {
	/* border-radius: 8px; */
	/* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
	flex: .3;
}

.CustomerfillingDig-tab-btn {
	text-align: center;
	margin-top: 30px;
}

.rechargeType-tab-btn {
	margin-top: 80px !important;
}

.billOperationRecord-page {
	padding-right: 40px;
	text-align: right;
	margin-top: 20px;
	padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
	margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
	margin-right: 10px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
	overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
	overflow: auto !important;
}

.public_icon_width {
	width: 80px;
}

.levelmang-title {
	display: flex;
	color: #333;
	text-align: center;
	margin-bottom: 20px;

}

.levelmang-title div {
	padding: 10px 20px;
	background-color: #e3e3e3;
}

.levelmang-title .levelmang-title-active {
	background-color: #199FFF;
	color: #FFF;
}

.levelmang-table {
	border: 1px solid #e3e3e3;
}

.levelmang-table>li {
	display: flex;
}

.levelmang-table-head {
	text-align: center;
	background-color: #30A8FF;
	color: #FFF;
}

.levelmang-table-head>div {
	height: 50px;
	line-height: 50px;
	border-left: 1px solid #e3e3e3;
	box-sizing: border-box;
	overflow: hidden;
}

.levelmang-table-head>div:first-child {
	border: none;
}

.levelmang-table-CQ {
	flex: 1;
	position: relative;
	padding: 5px 10px;
}

.levelmang-table-CQ-list {
	border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-JB {
	width: 240px;
}

.levelmang-table-KJ,
.levelmang-table-ZK,
.levelmang-table-YH {
	width: 295px;
}

.levelmang-table-ZK input,
.levelmang-table-YH input {
	text-align: center;
}

.levelmang-table-li {
	text-align: center;
}

.levelmang-table-li-tab-li {

	border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-li-tab-li:last-child {
	/* border: none; */
}

.levelmang-table-li-tab-li>div {
	border-left: 1px solid #e3e3e3;
	padding: 0 10px;
	box-sizing: border-box;
	height: 50px;
	line-height: 50px;
	vertical-align: top;
	overflow: hidden;
}

.levelmang-table-li-tab-li>div>input {
	width: 100px;
	border: 1px solid #e3e3e3;
	height: 35px;
	line-height: 35px;
	border-radius: 5px;
	margin-right: 10px;
}

.levelmang-table-CQ>div {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 100%;
	transform: translate(-50%, -50%);
}

.levelmang-table-li-tab-li {
	display: flex;
}

.userfptj {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}

.billOperationRecord-table {
	padding: 30px 20px 0;
}

/* 分组列容器的样式 */
.group-column {
	border: 2px solid #8f9091 !important;
	border-right: none !important;
}

/* 分组数据单元格样式 */
.group-cell {
	border-left: 1px solid #8f9091 !important;
	border-bottom: 1px solid #8f9091 !important;
}

.el-table__row:not(:last-child) .group-cell {
	border-bottom: none !important;
}

.tableColumn_detail::before {
	background-color: transparent !important;
}

.tableColumn_detail::after {
	background-color: #8f9091 !important;
}

/deep/.el-select.public_optionSty .el-input input {
	width: 160px !important;
	padding-right: 10px !important;
}
</style>